/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description URL Configs
 */

/**
 * WEBSITE_URL
 * @type {string}
 * @exports
 */
const WEBSITE_URL = 'veritable.app';

/**
 * PLAN_DETAILS_URL
 * @type {string}
 * @exports
 */
const PLAN_DETAILS_URL = `https://www.${WEBSITE_URL}/pricing`;

/**
 * CONTACT_US_URL
 * @type {string}
 * @exports
 */
const CONTACT_US_URL = `https://www.${WEBSITE_URL}/contact-us`;

/**
 * PRIVACY_POLICY_URL
 * @type {string}
 * @exports
 */
const PRIVACY_POLICY_URL = `https://www.${WEBSITE_URL}/privacy-policy/`;

/**
 * marker.io production project id
 */
const MARKER_IO_PRODUCTION_PROJECT_ID = '660a51d57df7379f23f96012';

/**
 * marker.io integration project id
 */
const MARKER_IO_INTEGRATION_PROJECT_ID = '678f817a3d984251f4493c7d';

/**
 * post hog api key for integration
 */
const POST_HOG_INTEGRATION_API_KEY = 'phc_I15oYekf4jk3IeB8C1Ny3rN98unJJdFe8vPo0sPjZiV';

/**
 * post hog api key for production
 */
const POST_HOG_PRODUCTION_API_KEY = 'phc_7wSZBTEV2GZAsS63GkAS0kEpHJlia0X550S9hjItWIe';

/**
 * posthog ui host
 */
const POSTHOG_UI_HOST = 'https://us.i.posthog.com';

export {
	WEBSITE_URL,
	PLAN_DETAILS_URL,
	CONTACT_US_URL,
	PRIVACY_POLICY_URL,
	MARKER_IO_PRODUCTION_PROJECT_ID,
	MARKER_IO_INTEGRATION_PROJECT_ID,
	POST_HOG_INTEGRATION_API_KEY,
	POST_HOG_PRODUCTION_API_KEY,
	POSTHOG_UI_HOST,
};
